module.exports = __webpack_public_path__ + "static/media/allergic-to.c440cebf.svg";